<template>
  <div class="text-center">
    <v-dialog
      v-model="$store.projectsStore.state.editProjectModal"
      max-width="700"
      scrollable
    >
      <v-card>
        <v-card-text class="pa-0">
          <div class="py-4 px-6">

            <!-- Header -->
            <div class="d-flex flex-row align-center justify-space-between mb-4">
              <div class="d-flex flex-row align-center">
                <v-icon color="white" small class="info-icon mr-2">mdi-file-document-multiple-outline</v-icon>
                <p class="mb-0 font-weight-bold text-primary title">Editar Proyecto</p>
              </div>
              <v-btn icon small @click="closeModal">
                <v-icon color="#F4516C">mdi-close</v-icon>
              </v-btn>
            </div>

            <v-form ref="form" v-model="validform">

              <!-- Empresa + ID -->
              <v-row dense>
                <v-col cols="12" md="6" class="py-1">
                  <label class="field-label">Empresa</label>
                  <div class="d-flex flex-row align-center">
                    <v-select
                      v-model="newProjectData.company_id"
                      :items="$store.userStore.state.userCompanies"
                      :loading="!$store.userStore.state.userInfo"
                      item-text="company.name"
                      item-value="company.id"
                      label="Seleccione Empresa"
                      single-line
                      outlined
                      dense
                      required
                      :rules="requiredRule"
                      hide-details="auto"
                    ></v-select>
                    <v-btn icon small color="#5E85EF" class="ml-1"
                      @click="$store.projectsStore.commit('setNewCompanyModal', true)">
                      <v-icon small>mdi-plus-circle-outline</v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <label class="field-label">ID del Proyecto</label>
                  <v-text-field
                    v-model="newProjectData.internal_id"
                    placeholder="Identificador del proyecto"
                    outlined
                    required
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Nombre + Tipo -->
              <v-row dense>
                <v-col cols="12" md="6" class="py-1">
                  <label class="field-label">Nombre</label>
                  <v-text-field
                    v-model="newProjectData.name"
                    placeholder="Nombre del proyecto"
                    outlined
                    required
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6" class="py-1">
                  <label class="field-label">Tipo</label>
                  <v-select
                    v-model="newProjectData.project_type_id"
                    :items="$store.projectsStore.state.projectTypes"
                    item-text="name"
                    item-value="id"
                    label="Seleccione Tipo"
                    single-line
                    outlined
                    dense
                    required
                    hide-details="auto"
                    :rules="requiredRule"
                  ></v-select>
                </v-col>
              </v-row>

              <!-- Descripción -->
              <v-row dense>
                <v-col cols="12" class="py-1">
                  <label class="field-label">Descripción</label>
                  <v-text-field
                    v-model="newProjectData.description"
                    placeholder="Breve descripción del proyecto"
                    outlined
                    required
                    dense
                    hide-details="auto"
                    :rules="requiredRule"
                  ></v-text-field>
                </v-col>
              </v-row>

              <!-- Imagen -->
              <v-row dense>
                <v-col cols="12" class="py-1">
                  <label class="field-label">Imagen Proyecto <span class="optional-label">(Opcional)</span></label>
                  <v-file-input
                    v-model="newProjectData.project_image"
                    show-size
                    outlined
                    dense
                    hide-details
                    accept=".png,.jpg,.jpeg"
                    placeholder="Imagen portada proyecto"
                    prepend-inner-icon="mdi-image"
                    prepend-icon=""
                  ></v-file-input>
                </v-col>
              </v-row>

              <!-- Especialidades -->
              <v-row dense class="mt-2 mb-4">
                <v-col cols="12" md="3" class="py-0">
                  <h2 class="mb-0 subtitle-1 font-weight-bold">Especialidades</h2>
                  <p class="mb-0 caption">(Opcional)</p>
                </v-col>
                <v-col cols="12" md="9" class="py-0">
                  <v-text-field
                    v-model="newEspecialidad"
                    placeholder="Escribe la nueva especialidad..."
                    outlined
                    dense
                    hide-details
                    class="custom-text-input"
                    @keydown.enter.prevent="addNewEspecialidad"
                  >
                    <template v-slot:append>
                      <v-btn
                        icon
                        small
                        :disabled="!newEspecialidad || newEspecialidad === ''"
                        color="#5E85EF"
                        @click="addNewEspecialidad()"
                      >
                        <v-icon small>mdi-plus-circle</v-icon>
                      </v-btn>
                    </template>
                  </v-text-field>
                  <div v-if="especialidades && especialidades.length" class="mt-2">
                    <v-btn
                      text
                      small
                      color="#2D4B95"
                      class="text-none"
                      @click="showEspecialidadesList = !showEspecialidadesList"
                    >
                      <v-icon small class="mr-1">{{ showEspecialidadesList ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      {{ showEspecialidadesList ? 'Ocultar' : 'Ver' }} especialidades ({{ especialidades.length }})
                    </v-btn>
                    <v-list dense v-show="showEspecialidadesList" class="mt-1">
                      <v-list-item dense v-for="(especialidad, i) in especialidades" :key="`specialty-${i}`">
                        <v-list-item-content>
                          <v-list-item-title>
                            <v-icon small color="#2D4B95" class="mr-2">mdi-label-outline</v-icon>
                            {{ especialidad.name }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon color="#F4516C" @click="removeEspecialidad(i)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-col>
              </v-row>

              <!-- Códigos -->
              <v-row class="mt-2 mb-4">
                <v-col cols="12" md="3" class="py-0">
                  <h2 class="mb-0 subtitle-1 font-weight-bold">Códigos</h2>
                  <p class="mb-0 caption">(Opcional)</p>
                </v-col>
                <v-col cols="12" md="9" class="py-0">
                  <div class="d-flex flex-row align-center">
                    <FilterMenu
                      v-model="selectedTaskCodeIds"
                      :items="taskCodesList"
                      :label="codesFilterLabel"
                      :itemValue="'id'"
                      :itemText="formatTaskCodeText"
                      :searchEnabled="true"
                      searchPlaceholder="Buscar código..."
                      :maxHeight="300"
                      :listTitle="'Códigos disponibles'"
                      :activatorLoading="loadingTaskCodes"
                      :activatorClass="'project-codes-filter-btn d-flex flex-row pa-0 justify-start'"
                      :activatorStyle="'height: auto;'"
                      @apply="onApplyTaskCodes"
                    />
                  </div>
                  <v-row dense class="mt-2">
                    <v-col cols="12" md="3" class="py-0">
                      <v-text-field
                        v-model="newTaskCode.sku"
                        label="Sigla"
                        placeholder="Ej: LOD"
                        outlined
                        dense
                        maxlength="10"
                      />
                    </v-col>
                    <v-col cols="12" md="6" class="py-0">
                      <v-text-field
                        v-model="newTaskCode.specialties"
                        label="Nombre"
                        placeholder="Ej: Libro de Obra Digital"
                        outlined
                        dense
                        @keydown.enter.prevent="addNewTaskCode"
                      />
                    </v-col>
                    <v-col cols="12" md="3" class="py-0 d-flex align-center">
                      <v-btn
                        class="mb-5"
                        color="#5E85EF"
                        outlined
                        small
                        @click="addNewTaskCode"
                      >
                        <v-icon left small>mdi-plus</v-icon>
                        Agregar
                      </v-btn>
                    </v-col>
                  </v-row>
                  <div v-if="newTaskCodes.length > 0" class="mt-n2">
                    <v-btn
                      text
                      small
                      color="#2D4B95"
                      class="text-none"
                      @click="showCodigosList = !showCodigosList"
                    >
                      <v-icon small class="mr-1">{{ showCodigosList ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      {{ showCodigosList ? 'Ocultar' : 'Ver' }} códigos nuevos ({{ newTaskCodes.length }})
                    </v-btn>
                    <v-list dense v-show="showCodigosList" class="mt-1">
                      <v-list-item dense v-for="(code, index) in newTaskCodes" :key="`new-code-${index}`">
                        <v-list-item-content>
                          <v-list-item-title>
                            <span class="light-blue-text">[{{ code.sku }}]</span> - {{ code.specialties }}
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-btn icon color="#F4516C" @click="removeNewTaskCode(index)">
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                  </div>
                </v-col>
              </v-row>

              <!-- Ubicación Geográfica -->
              <v-row dense class="mt-2 mb-4">
                <v-col cols="12" class="py-0">
                  <LocationPicker
                    :latitude.sync="newProjectData.latitude"
                    :longitude.sync="newProjectData.longitude"
                    :address.sync="newProjectData.address"
                    label="Ubicación del Proyecto"
                  />
                </v-col>
              </v-row>

              <!-- Divider: Datos del Proyecto -->
              <v-row dense class="mt-3">
                <v-col cols="12" class="py-1">
                  <div class="section-header d-flex flex-row align-center">
                    <v-icon color="white" x-small class="info-icon-sm mr-2">mdi-file-document-multiple-outline</v-icon>
                    <p class="mb-0 font-weight-bold text-primary subtitle-2">Datos del Proyecto</p>
                  </div>
                </v-col>
              </v-row>

              <!-- Moneda + Monto + Plazo + Fecha -->
              <v-row dense>
                <v-col cols="12" md="3" class="py-1">
                  <label class="field-label">Moneda</label>
                  <v-select
                    v-model="newProjectData.currency"
                    :items="currencyType"
                    item-text="name"
                    item-value="id"
                    label="Tipo"
                    single-line
                    outlined
                    dense
                    required
                    hide-details="auto"
                    :rules="requiredRule"
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" class="py-1">
                  <label class="field-label">Monto Contrato</label>
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.contract_value > 0 ? newProjectData.contract_value-- : null">−</button>
                    <input v-model="newProjectData.contract_value" type="number" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.contract_value++">+</button>
                  </div>
                </v-col>
                <v-col cols="12" md="3" class="py-1">
                  <label class="field-label">Plazo (Días)</label>
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.total_days > 0 ? newProjectData.total_days-- : null">−</button>
                    <input v-model="newProjectData.total_days" type="number" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.total_days++">+</button>
                  </div>
                </v-col>
                <v-col cols="12" md="3" class="py-1">
                  <label class="field-label">Fecha Inicio</label>
                  <v-menu
                    v-model="datePicker"
                    :close-on-content-click="false"
                    max-width="290"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="newProjectData.start_date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        dense
                        hide-details
                        class="remove-bottom-details date-limit-input"
                        @click:clear="date = null"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="newProjectData.start_date"
                      @change="datePicker = false"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <!-- Divider: Tipos de Adicional -->
              <v-row dense class="mt-3">
                <v-col cols="12" class="py-1">
                  <div class="section-header d-flex flex-row align-center">
                    <v-icon color="white" x-small class="info-icon-sm mr-2">mdi-file-document-multiple-outline</v-icon>
                    <p class="mb-0 font-weight-bold text-primary subtitle-2">Configuración Tipos de Adicional</p>
                  </div>
                </v-col>
              </v-row>

              <!-- Tabla de adicionales -->
              <v-row dense class="additional-table-header">
                <v-col cols="4" class="py-1"><span class="table-header-label">Tipo</span></v-col>
                <v-col cols="4" class="py-1"><span class="table-header-label">Gastos Generales (%)</span></v-col>
                <v-col cols="4" class="py-1"><span class="table-header-label">Utilidad (%)</span></v-col>
              </v-row>

              <!-- Obra Extraordinaria -->
              <v-row dense align="center" class="additional-row">
                <v-col cols="4" class="py-1">
                  <span class="row-label">Obra Extraordinaria</span>
                </v-col>
                <v-col cols="4" class="py-1">
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.oe_gg = (parseFloat(newProjectData.oe_gg) > 0 ? +(parseFloat(newProjectData.oe_gg) - 0.00001).toFixed(5) : 0)">−</button>
                    <input v-model="newProjectData.oe_gg" type="number" step="0.00001" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.oe_gg = +((parseFloat(newProjectData.oe_gg) || 0) + 0.00001).toFixed(5)">+</button>
                  </div>
                </v-col>
                <v-col cols="4" class="py-1">
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.oe_profit = (parseFloat(newProjectData.oe_profit) > 0 ? +(parseFloat(newProjectData.oe_profit) - 0.00001).toFixed(5) : 0)">−</button>
                    <input v-model="newProjectData.oe_profit" type="number" step="0.00001" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.oe_profit = +((parseFloat(newProjectData.oe_profit) || 0) + 0.00001).toFixed(5)">+</button>
                  </div>
                </v-col>
              </v-row>

              <!-- Aumento de Obra -->
              <v-row dense align="center" class="additional-row">
                <v-col cols="4" class="py-1">
                  <span class="row-label">Aumento de Obra</span>
                </v-col>
                <v-col cols="4" class="py-1">
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.ao_gg = (parseFloat(newProjectData.ao_gg) > 0 ? +(parseFloat(newProjectData.ao_gg) - 0.00001).toFixed(5) : 0)">−</button>
                    <input v-model="newProjectData.ao_gg" type="number" step="0.00001" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.ao_gg = +((parseFloat(newProjectData.ao_gg) || 0) + 0.00001).toFixed(5)">+</button>
                  </div>
                </v-col>
                <v-col cols="4" class="py-1">
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.ao_profit = (parseFloat(newProjectData.ao_profit) > 0 ? +(parseFloat(newProjectData.ao_profit) - 0.00001).toFixed(5) : 0)">−</button>
                    <input v-model="newProjectData.ao_profit" type="number" step="0.00001" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.ao_profit = +((parseFloat(newProjectData.ao_profit) || 0) + 0.00001).toFixed(5)">+</button>
                  </div>
                </v-col>
              </v-row>

              <!-- Disminución de Obra -->
              <v-row dense align="center" class="additional-row mb-2">
                <v-col cols="4" class="py-1">
                  <span class="row-label">Disminución de Obra</span>
                </v-col>
                <v-col cols="4" class="py-1">
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.do_gg = (parseFloat(newProjectData.do_gg) > 0 ? +(parseFloat(newProjectData.do_gg) - 0.00001).toFixed(5) : 0)">−</button>
                    <input v-model="newProjectData.do_gg" type="number" step="0.00001" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.do_gg = +((parseFloat(newProjectData.do_gg) || 0) + 0.00001).toFixed(5)">+</button>
                  </div>
                </v-col>
                <v-col cols="4" class="py-1">
                  <div class="stepper-input">
                    <button type="button" class="stepper-btn stepper-minus" @click="() => newProjectData.do_profit = (parseFloat(newProjectData.do_profit) > 0 ? +(parseFloat(newProjectData.do_profit) - 0.00001).toFixed(5) : 0)">−</button>
                    <input v-model="newProjectData.do_profit" type="number" step="0.00001" class="stepper-field" placeholder="0" />
                    <button type="button" class="stepper-btn stepper-plus" @click="() => newProjectData.do_profit = +((parseFloat(newProjectData.do_profit) || 0) + 0.00001).toFixed(5)">+</button>
                  </div>
                </v-col>
              </v-row>

              <!-- Acciones -->
              <v-row dense>
                <v-col cols="12" class="py-2">
                  <div class="d-flex flex-row justify-end">
                    <v-btn
                      class="mr-2"
                      rounded
                      outlined
                      color="#2D4B95"
                      small
                      @click="closeModal"
                    >
                      Cancelar
                    </v-btn>
                    <v-btn
                      rounded
                      color="#2D4B95"
                      dark
                      small
                      :loading="loadingData"
                      @click="sendForm"
                    >
                      Confirmar
                    </v-btn>
                  </div>
                </v-col>
              </v-row>

            </v-form>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {getProjectTypes, update, searchUsersByEmail} from '@/helpers/api/project'
import {getTasksRestrictionsCodes} from '@/helpers/api/tasks'
import FilterMenu from '@/components/Globals/Helpers/FilterMenu'
import LocationPicker from '@/components/Globals/Helpers/LocationPicker'
export default {
  name: 'EditProjectModal',
  components: {FilterMenu, LocationPicker},
  data: () => ({
    validform: true,
    newProjectData: {
      id: null,
      company_id: null,
      internal_id: null,
      name: null,
			address: null,
      description: null,
      project_type_id: null,
      contract_value: 0,
      total_days: 0,
      start_date: null,
      currency: 1,
      project_image: null,
			oe_gg: null,
			oe_profit: null,
			ao_gg: null,
			ao_profit: null,
      do_gg: null,
			do_profit: null,
      task_code_ids: null,
      new_task_codes: null,
      latitude: null,
      longitude: null,
    },
    datePicker: false,
    minDate: new Date().toISOString().slice(0,10),
    requiredRule: [
      v => !!v || 'Campo requerido'
    ],
    especialidades: [],
    newEspecialidad: '',
    taskCodesList: [],
    loadingTaskCodes: false,
    selectedTaskCodeIds: [],
    newTaskCode: {
      sku: '',
      specialties: ''
    },
    newTaskCodes: [],
    showEspecialidadesList: false,
    showCodigosList: false,
    loadingData: false,
    loadingUsers: false,
    usersToSelect: [],
    searchUsers: null,
  }),
  computed: {
    currencyType(){
      return this.$store.generalStore.state.systemCurrencies.currencies
    },
    codesFilterLabel(){
      return this.selectedTaskCodeIds.length > 0 ? `Códigos (${this.selectedTaskCodeIds.length})` : 'Seleccionar códigos'
    }
  },
  watch: {
    searchUsers (val) {
      if(val.length > 5){
        this.searchUsersBD(val)
      }
    },
  },
  mounted(){
    if(!this.$store.projectsStore.state.projectTypes){
      this.projectTypesGet()
    }
    this.loadTaskCodes()
    this.setProjectData()
  },
  methods: {
    setProjectData(){
      const project = {...this.$store.projectsStore.state.selectedProject}
			console.log('project', project)
      this.newProjectData = {
        id: project.id,
        internal_id: project.internal_id,
        company_id: project.company_id,
        name: project.name,
        address: project.address,
        description: project.description,
        project_type_id: project.project_type_id,
        contract_value: project.details ? project.details.contract_value:null,
        total_days: project.details ? project.details.total_days:null,
        start_date: project.details ? project.details.start_date:null,
        currency: project.details ? project.details.currency:null,
        project_image: null,
        especialidades: project.specialties,
				oe_gg: project.additional_options ? project.additional_options.oe_gg:null,
				oe_profit: project.additional_options ? project.additional_options.oe_profit:null,
				ao_gg: project.additional_options ? project.additional_options.ao_gg:null,
        ao_profit: project.additional_options ? project.additional_options.ao_profit:null,
				do_gg: project.additional_options ? project.additional_options.do_gg:null,
				do_profit: project.additional_options ? project.additional_options.do_profit:null,
        task_code_ids: null,
        new_task_codes: null,
        latitude: project.geo ? project.geo.latitude : null,
        longitude: project.geo ? project.geo.longitude : null,
      }
      this.especialidades = project.specialties
      this.selectedTaskCodeIds = (project.task_codes || []).map((code) => code.id)
      this.newProjectData.project_image = null
    },
    closeModal(){
      this.validform = true
      this.newProjectData = {
        id: null,
        company_id: null,
        internal_id: null,
        name: null,
				address: null,
        description: null,
        project_type_id: null,
        contract_value: 0,
        total_days: 0,
        start_date: null,
        currency: 1,
        project_image: null,
				oe_gg: null,
				oe_profit: null,
				ao_gg: null,
        ao_profit: null,
				do_gg: null,
				do_profit: null,
        task_code_ids: null,
        new_task_codes: null,
        latitude: null,
        longitude: null,
      }
      this.datePicker = false
      this.minDate = new Date().toISOString().slice(0,10)
      this.especialidades = []
      this.selectedTaskCodeIds = []
      this.newTaskCode = {sku: '', specialties: ''}
      this.newTaskCodes = []
      this.newEspecialidad = ''
      this.loadingData = false
      this.loadingUsers = false
      this.usersToSelect = []
      this.searchUsers = null
      this.$store.projectsStore.commit('setEditProjectModal', false)
    },
    async loadTaskCodes(){
      this.loadingTaskCodes = true
      const response = await getTasksRestrictionsCodes()
      if(response.code === 200){
        this.taskCodesList = response.task_codes || []
      }
      this.loadingTaskCodes = false
    },
    addNewTaskCode(){
      const sku = (this.newTaskCode.sku || '').trim().toUpperCase()
      const specialties = (this.newTaskCode.specialties || '').trim()
      if(!sku || !specialties){
        return
      }
      const exists = this.newTaskCodes.some((code) => code.sku === sku && code.specialties.toLowerCase() === specialties.toLowerCase())
      if(exists){
        return
      }
      this.newTaskCodes.push({sku, specialties})
      this.newTaskCode = {sku: '', specialties: ''}
    },
    removeNewTaskCode(index){
      this.newTaskCodes.splice(index, 1)
    },
    formatTaskCodeText(code){
      if(!code){
        return ''
      }
      return `[${code.sku}] - ${code.specialties}`
    },
    onApplyTaskCodes(){
      // La selección se actualiza vía v-model, no requiere lógica adicional.
    },
    async searchUsersBD(email){
      this.loadingUsers = true
      const users = await searchUsersByEmail({email})
      if(users.code === 200){
        this.usersToSelect = users.users
      }
      this.loadingUsers = false
    },
    usersFilter(item, queryText) {
      const name = item.name.toLowerCase()
      const email = item.email.toLowerCase()
      const searchText = queryText.toLowerCase()

      return name.indexOf(searchText) > -1 || email.indexOf(searchText) > -1
    },
    async projectTypesGet(){
      const projectTypes = await getProjectTypes()
      if(projectTypes.code === 200){
        this.$store.projectsStore.commit('setProjectTypes', projectTypes.project_types)
      }
    },
    addNewEspecialidad(){
      this.especialidades.push({name: this.newEspecialidad, parent_id: null})
      this.newEspecialidad = ''
    },
    removeEspecialidad(i){
      this.especialidades.splice(i, 1)
    },
    async sendForm(){
      if(this.$refs.form.validate()){
        this.loadingData = true
        this.loadingData = false
        const formData = new FormData()
        this.newProjectData.especialidades = JSON.stringify(this.especialidades)
        this.newProjectData.task_code_ids = JSON.stringify(this.selectedTaskCodeIds)
        this.newProjectData.new_task_codes = this.newTaskCodes.length > 0 ? JSON.stringify(this.newTaskCodes) : null
        Object.keys(this.newProjectData).forEach((key) => {
          if(this.newProjectData[key]){
            formData.append(key, this.newProjectData[key])
          }
        })
        const project = await update(formData)
        if(project.code === 200){
          this.closeModal()
          this.$store.projectsStore.commit('setSelectedProject', project.project)
        }
        this.loadingData = false
      }
    }
  }
};
</script>

<style scoped>
  .text-primary { color: #2D4B95; }

  .info-icon {
    background-color: #2D4B95;
    border-radius: 50%;
    padding: 3px;
    width: 28px;
    height: 28px;
  }
  .info-icon-sm {
    background-color: #2D4B95;
    border-radius: 50%;
    padding: 2px;
    width: 20px;
    height: 20px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .field-label {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #444;
    margin-bottom: 2px;
  }
  .optional-label {
    font-weight: 400;
    color: #888;
    font-size: 11px;
  }

  .section-header {
    border-bottom: 1px solid #e0e6f5;
    padding-bottom: 4px;
    margin-bottom: 4px;
  }

  .additional-table-header {
    background-color: #f5f7fc;
    border-radius: 6px 6px 0 0;
    padding: 2px 8px;
    margin-top: 4px;
  }
  .table-header-label {
    font-size: 11px;
    font-weight: 600;
    color: #2D4B95;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .additional-row {
    padding: 0 8px;
    border-bottom: 1px solid #f0f0f0;
  }
  .row-label {
    font-size: 13px;
    font-weight: 500;
    color: #444;
  }

  .especialidades-list {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 4px;
  }
  .especialidad-chip {
    background-color: #e8edf8;
    border-radius: 20px;
    padding: 2px 8px 2px 10px;
    display: inline-flex;
    align-items: center;
  }
  .especialidad-name {
    font-size: 12px;
    color: #2D4B95;
    font-weight: 500;
  }

  /deep/ .custom-text-input .v-input__append-inner { margin-top: 0 !important; }
  /deep/ .v-text-field--outlined.v-input--dense .v-input__control { min-height: 36px; }

  /* Stepper input */
  .stepper-input {
    display: flex;
    align-items: center;
    border: 1px solid rgba(0,0,0,0.24);
    border-radius: 6px;
    overflow: hidden;
    height: 36px;
    transition: border-color 0.2s;
  }
  .stepper-input:hover {
    border-color: rgba(0,0,0,0.6);
  }
  .stepper-input:focus-within {
    border-color: #2D4B95;
    box-shadow: 0 0 0 1px #2D4B95;
  }
  .light-blue-text{color: #5E85EF;}
  /deep/ .project-codes-filter-btn.v-btn{
    border: 1px solid #d0d5dd;
    border-radius: 4px;
    min-height: 40px;
    padding: 0 12px!important;
    background-color: #fff;
  }
  /deep/ .project-codes-filter-btn.v-btn p{
    font-size: 13px;
    color: #2D4B95;
    font-weight: 600;
  }
  /deep/ .project-codes-filter-btn.v-btn .v-icon{
    color: #5E85EF!important;
  }
  .interaction-container .icon-arrow{
    font-size: 80px;
    position: absolute;
    top: 20px;
    line-height: inherit;
  }
  .interaction-container.right .icon-arrow{
    left: -46px;
	}
  .stepper-btn {
    flex-shrink: 0;
    width: 30px;
    height: 100%;
    border: none;
    outline: none;
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s, color 0.15s;
    user-select: none;
    color: #2D4B95;
    background-color: #f0f4ff;
  }
  .stepper-btn:hover {
    background-color: #2D4B95;
    color: #fff;
  }
  .stepper-btn:active {
    background-color: #1e3578;
    color: #fff;
  }
  .stepper-btn:disabled {
    color: #bbb;
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
  .stepper-field {
    flex: 1;
    min-width: 0;
    height: 100%;
    border: none;
    outline: none;
    text-align: center;
    font-size: 13px;
    color: #333;
    background: transparent;
    padding: 0 4px;
  }
  /* Hide native number spinners */
  .stepper-field::-webkit-inner-spin-button,
  .stepper-field::-webkit-outer-spin-button { -webkit-appearance: none; margin: 0; }
  .stepper-field[type=number] { -moz-appearance: textfield; }
</style>